module.exports = __webpack_public_path__ + "img/text2.ea5728bb.png";